import React, { useState, useEffect } from 'react';
import { arrayOf, shape, string } from 'prop-types';
import './emt-links.scss';

export const Links = ({ links }) => {

  if (links.length === 0) {
    return null;
  }

  return (
    <ul className="emt-links-sets__links">
      {
        links.map((link, i) => {
          return (
            <li className="emt-links-sets__links__keyword" key={`setLink_${link.keyword}_${i}`}>
              <a href={link.url} className="emt-links-sets__links__link" title={link.keyword}>{link.keyword}</a>
            </li>
          );
        })
      }
    </ul>
  );
};

Links.propTypes = {
  links: arrayOf(shape({
    url: string.isRequired,
    keyword: string.isRequired,
  })).isRequired
};
